import { biLoggerFactory } from 'wix-private';
 
const msid = 'f214b800-ead5-49af-b57e-70a2bf48a3ab'; //replace the value between quotes with your site msid value
 
/**
 * biGroupsLoggers it's an Object with key:value pair
 * key: represents src of the BI group
 * value: represents the biLogger function for that group
 * */
 
const biGroupsLoggers = {
    
    19: biLoggerFactory('lp', 19, { msid }),
    
}
 
export async function fireBIEvent(src, evid, fields) {
 
    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}

const biGroupsLoggers2 = {
    
    19: biLoggerFactory('fb-ads-lp', 19, { msid }),
    
}
 
export async function fireBIEvent2(src, evid, fields) {
 
    const biLogger = biGroupsLoggers2[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}
